import React, { useCallback, useState } from "react";
import { Form, TextArea } from "semantic-ui-react";
import { useFormik } from "formik";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./RoleForm.form";
import "./RoleForm.scss";
import { useLanguage } from "../../../../contexts";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const roleController = new Role();

export function RoleForm(props) {
  const { onClose, onReload, role } = props;
  const { accessToken } = useAuth();

  const { translations } = useLanguage();

  const navigate = useNavigate();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const formik = useFormik({
    initialValues: initialValues(role),
    validationSchema: validationSchema(role),
    validateOnChange: false,
    onSubmit: async (formValue, { setSubmitting }) => {
      try {
        if (!role) {
          const response = await roleController.createRole(
            accessToken,
            formValue,
          );
          if (response.code === 200) {
            toast.success("Formulario enviado correctamente!");
          } else {
            toast.error(`Error: ${response.msg}`);
          }
        } else {
          const response2 = await roleController.updateRole(
            accessToken,
            role._id,
            formValue,
          );
          if (response2.code === 200) {
            toast.success("Formulario actualizado correctamente!");
          } else {
            toast.error(`Error: ${response2.msg}`);
          }
        }
        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          // Cerrar el modal
          onClose();

          // O recargar la página
          onReload();
        }, 1500);
      } catch (error) {
        toast.error(
          `Error: ${error.msg ? error.msg : "Error en el servidor intente nuevamente"}`,
        );
      } finally {
        setSubmitting(false); // Se asegura de que Formik termine su proceso de envío
      }
    },
  });

  const goBack = () => {
    navigate(`/admin/config/roles`, {
      //state: { siteSelected: siteSelected },
    });
  };

  return (
    <Form className="role-form" onSubmit={formik.handleSubmit}>
      <Form.Group widths="equal">
        <Form.Input
          label={
            <>
              <span style={{ color: "red" }}>*</span>{" "}
              <span style={{ fontWeight: "bold" }}>{t("role")}</span>
            </>
          }
          name="name"
          placeholder={t("role")}
          onChange={formik.handleChange}
          value={formik.values.name}
          error={formik.errors.name}
        />
      </Form.Group>

      <Form.TextArea
        style={{ minHeight: 100 }}
        label={<span style={{ fontWeight: "bold" }}>{t("description")}</span>}
        name="description"
        placeholder={t("description")}
        onChange={formik.handleChange}
        value={formik.values.description}
        error={formik.errors.description}
      />

      <div className="role-form__actions">
        <Form.Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={role ? t("update") : t("create")}
        />

        <Form.Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Form.Button>
      </div>

      {/* Este es el contenedor que maneja las tostadas */}
      <ToastContainer
        position="top-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Form>
  );
}
